import type { UpdateTenantTrainingConfigInput } from '@lms/shared'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '@/lib/api'

export function useTenantTrainingConfig() {
  return useQuery({
    queryKey: ['tenant-training-config'],
    queryFn: () => api.get('/api/tenant-training-config'),
  })
}

export function useUpdateTenantTrainingConfig() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (data: UpdateTenantTrainingConfigInput) =>
      api.put('/api/tenant-training-config', data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['tenant-training-config'] }),
  })
}
